// src/components/JobDetails.js
import React from "react";
import { Card, CardContent, Typography, Grid, IconButton ,Chip ,Box ,Stack,Link, Link as MuiLink} from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import { Facebook, Twitter, LinkedIn, ContentCopy } from "@mui/icons-material";
import { HelmetProvider } from "react-helmet-async";
import SEO from "../SEO";
import hrImage from "../../images/hr-image.jpg";

const JobDetails = ({ job, onCopyLink }) => {
  const jobUrl = window.location.href;
  const encodedJobUrl = encodeURIComponent(jobUrl);

  return (
    <Card elevation={3} sx={{ marginY: 0, padding:0 }}>
      <SEO
        title={`Discover Exciting Career Opportunities with Unified Networks Solution - Join a Leader in Innovative IT and Network Solutions`}
        description="Advance your career with UFS Networks—explore job opportunities in software development, AI, DevOps, and cybersecurity. Join a leading tech company driving innovation and digital transformation."
        url={`${encodedJobUrl}`}
        image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
      />
      <CardContent>
        <Typography variant="h4" sx={{fontSize:"24px", fontWeight:"500", marginBottom:"12px"}} gutterBottom>
          {job.title}
        </Typography>


<Box sx={{ display: "flex", marginBottom: 2, flexWrap: "wrap" }}>
  <Stack
    direction={{ xs: "column", sm: "row" }} 
    spacing={.5}
    flexWrap="wrap"
    sx={{
      gap:.5, // Add space between chips
      width: "100%", // Ensure Stack takes full width
    }}
  >
    <Chip label={`Location: ${job.location}${job.state ? `, ${job.state}` : ''}`} color="primary" variant="outlined" sx={{ marginBottom: 1, fontSize:"13px", height:"30px" }} />
    <Chip label={`Experience: ${job.experience}`} color="secondary" variant="outlined" sx={{ marginBottom: 1, fontSize:"13px", height:"30px" }} />
    <Chip label={`Skillset: ${job.skillset}`} color="success" variant="outlined" sx={{ marginBottom: 1, fontSize:"13px", height:"30px" }} />
    <Chip label={`Job Type: ${job.jobType}`} color="warning" variant="outlined" sx={{ marginBottom: 1, fontSize:"13px", height:"30px" }} />
    <Chip label={`Department: ${job.department}`} color="info" variant="outlined" sx={{ marginBottom: 1, fontSize:"13px", height:"30px" }} />
    {job.jobMode && (<Chip label={`Job Mode: ${job.jobMode}`} color="success" variant="outlined" sx={{ marginBottom: 1, fontSize:"13px", height:"30px"}} />)}
  </Stack>
</Box>




        
<Typography variant="body1" className="jobDescription" sx={{fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: job.description }} gutterBottom />

{job.tags && job.tags.length > 0 && (
  <Box sx={{display:"flex"}}>
    <Typography variant="h6" sx={{marginRight:"6px", fontSize:"14px"}} gutterBottom>
      Tags:
    </Typography>
    <div>
      {job.tags.map((tag, index) => (
        <Chip key={index} label={tag} color="primary" variant="outlined" sx={{ marginRight:"4px", marginBottom: 1, fontSize:"11px", height:"22px" }} />
      ))}
    </div>
  </Box>
)}

<Card variant="outlined" sx={{
                    position: "relative",
                    border:"none",
                    display:"block",
                    background: "linear-gradient(45deg, #0045ff, #00a9c6)",
                    backgroundSize: "400% 400%",
                    marginTop:"24px",
                    textAlign:"left",
                    color: "#fff",
                    overflow:"visible",
                  }}
                >
                  <MuiLink component={RouterLink} to="/career" sx={{ padding: "0px !important", display:"flex", boxShadow:"0px 2px 10px #888", borderRadius:"4px" }}>
                    <img src={hrImage} alt="UFS Network jobs" style={{width:"50%"}} />
                    <Box>
                      <Typography
                        variant="h2"
                        sx={{
                          fontSize: "20px",
                          color: "#fff",
                          padding:"10px 10px 0px 10px"
                        }}
                      >
                        Exciting Job Opportunity with Our Client!
                      </Typography>
                      <Typography sx={{ color: "text.secondary", color: "#fff", fontSize: "13px", padding:"10px 10px" }}>
                        We're hiring on behalf of a reputed organization looking for talented professionals to join their team.
                      </Typography>
                      <Box>
                      <ul style={{fontSize:"13px", paddingLeft:"32px", color:"#fff"}}>
                        <li>Multiple positions open across departments</li>
                        <li>Work with an industry-leading company</li>
                        <li>Competitive salary & career growth</li>
                      </ul>
                      </Box>
                      <Box sx={{padding:"10px"}}>
                        <Typography component={Link} to="/career" sx={{width:"100%", fontSize: "14px", textAlign:"center", textDecoration:"none", color: "#000", marginTop: "4px", backgroundColor: "#fff", display: "block", padding: "12px 10px", border: "none", cursor:"pointer" }}>View jobs</Typography>
                      </Box>
                    </Box>
                  </MuiLink>
                </Card>


        {/* Social Sharing Buttons */}
        <Grid container spacing={1} sx={{ marginTop: 2 }}>
          <Grid item>
            <IconButton
              color="primary"
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodedJobUrl}`}
              target="_blank"
            >
              <Facebook />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="primary"
              href={`https://twitter.com/intent/tweet?url=${encodedJobUrl}`}
              target="_blank"
            >
              <Twitter />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="primary"
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedJobUrl}`}
              target="_blank"
            >
              <LinkedIn />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton color="primary" onClick={onCopyLink}>
              <ContentCopy />
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JobDetails;
